var GIT_VERSION_TAG = "N/A or No Production Version Tag was found";
var GIT_BRANCH = "GIT_BRANCH_PLACEHOLDER";
var GIT_COMMITHASH = "bbe780fcf8ab61a637d631cd045dec3ee76a6000";
var GIT_COMMITTIME = "GIT_COMMITTIME_PLACEHOLDER";
var BUILDTIME = "Thu, 31 Aug 2023 18:07:34 GMT";
var BUILD_NUMBER = "38";
var BUILD_UNIQUE_ID = "ochycg2xllzhax99";